import React from 'react'
import {
  ChevronRight,
  Search,
} from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
export default function ExploreContent() {
  return (
    <div className="px-3 pt-3">
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
      >
        <div className="flex items-center mb-4">
          <Search className="w-6 h-6 text-orange-500 mr-2" />
          <h1 className="text-white text-xl font-bold">Explorar</h1>
        </div>

        <div className="bg-gray-800 rounded-lg p-3 mb-4">
          <div className="relative">
            <Search className="w-4 h-4 text-gray-400 absolute left-3 top-1/2 transform -translate-y-1/2" />
            <input
              type="text"
              placeholder="Buscar equipos, ligas o eventos..."
              className="w-full bg-gray-700 text-white rounded-lg py-2 pl-9 pr-4 text-sm focus:outline-none"
            />
          </div>
        </div>

        <div className="grid grid-cols-2 gap-3 mb-6">
          <motion.div
            className="bg-gradient-to-br from-blue-800 to-blue-900 rounded-lg p-4 flex flex-col justify-between h-32"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            <div className="text-xl mb-1">⚽</div>
            <div>
              <h3 className="text-white font-medium">Fútbol</h3>
              <p className="text-blue-300 text-xs">230 eventos en vivo</p>
            </div>
          </motion.div>

          <motion.div
            className="bg-gradient-to-br from-green-800 to-green-900 rounded-lg p-4 flex flex-col justify-between h-32"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            <div className="text-xl mb-1">🏀</div>
            <div>
              <h3 className="text-white font-medium">Baloncesto</h3>
              <p className="text-green-300 text-xs">85 eventos en vivo</p>
            </div>
          </motion.div>

          <motion.div
            className="bg-gradient-to-br from-purple-800 to-purple-900 rounded-lg p-4 flex flex-col justify-between h-32"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            <div className="text-xl mb-1">🎾</div>
            <div>
              <h3 className="text-white font-medium">Tenis</h3>
              <p className="text-purple-300 text-xs">42 eventos en vivo</p>
            </div>
          </motion.div>

          <motion.div
            className="bg-gradient-to-br from-yellow-800 to-yellow-900 rounded-lg p-4 flex flex-col justify-between h-32"
            whileHover={{ scale: 1.03 }}
            whileTap={{ scale: 0.97 }}
          >
            <div className="text-xl mb-1">⚾</div>
            <div>
              <h3 className="text-white font-medium">Béisbol</h3>
              <p className="text-yellow-300 text-xs">38 eventos en vivo</p>
            </div>
          </motion.div>
        </div>

        <div className="mb-6">
          <div className="flex items-center justify-between mb-3">
            <h2 className="text-white font-medium">Competiciones populares</h2>
            <div className="flex items-center text-gray-400 hover:text-white cursor-pointer">
              <span className="text-xs mr-1">Ver todas</span>
              <ChevronRight className="w-4 h-4" />
            </div>
          </div>

          <div className="space-y-2">
            {[
              { name: "Champions League", icon: "🏆", region: "Europa" },
              { name: "Copa Libertadores", icon: "🏆", region: "Sudamérica" },
              { name: "Premier League", icon: "🏴󠁧󠁢󠁥󠁮󠁧󠁿", region: "Inglaterra" },
              { name: "La Liga", icon: "🇪🇸", region: "España" },
            ].map((competition, index) => (
              <motion.div
                key={index}
                className="bg-gray-800 rounded-lg p-3 flex justify-between items-center"
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
              >
                <div className="flex items-center">
                  <div className="mr-3 text-xl">{competition.icon}</div>
                  <div>
                    <span className="text-white block">{competition.name}</span>
                    <span className="text-gray-400 text-xs">
                      {competition.region}
                    </span>
                  </div>
                </div>
                <ChevronRight className="w-4 h-4 text-gray-400" />
              </motion.div>
            ))}
          </div>
        </div>
      </motion.div>
    </div>
  );
}
